export class BrowserHelper {
  static isIE(nav: Navigator): boolean {
    return nav.userAgent.indexOf('MSIE') != -1 || !!navigator.userAgent.match(/Trident\/7\./);
  }
}
